module.exports = __webpack_public_path__ + "img/delete.620b9843.svg";